/**
 * @param {number} level
 * @returns {HeadlineTag}
 */
const getHeadingTag = (level) => {
  if (level === 1) return 'h1';
  if (level === 2) return 'h2';
  if (level === 3) return 'h3';
  if (level === 4) return 'h4';
  if (level === 5) return 'h5';
  return 'h6';
};

export default getHeadingTag;
